
// @ts-nocheck


export const localeCodes =  [
  "en",
  "fr",
  "de",
  "es",
  "pt",
  "it"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_995fa198",
      load: () => import("#nuxt-i18n/995fa198" /* webpackChunkName: "locale_en_46json_995fa198" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_ef37d5e7",
      load: () => import("#nuxt-i18n/ef37d5e7" /* webpackChunkName: "locale_fr_46json_ef37d5e7" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_5f5672fd",
      load: () => import("#nuxt-i18n/5f5672fd" /* webpackChunkName: "locale_de_46json_5f5672fd" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_98313ec2",
      load: () => import("#nuxt-i18n/98313ec2" /* webpackChunkName: "locale_es_46json_98313ec2" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_7bc184eb",
      load: () => import("#nuxt-i18n/7bc184eb" /* webpackChunkName: "locale_pt_46json_7bc184eb" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_b846e21d",
      load: () => import("#nuxt-i18n/b846e21d" /* webpackChunkName: "locale_it_46json_b846e21d" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/d46389f1" /* webpackChunkName: "config_i18n_46config_46ts_d46389f1" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      language: "en-US",
      files: [
        "/root/front/i18n/locales/en.json"
      ]
    },
    {
      code: "fr",
      name: "Français",
      language: "fr-FR",
      files: [
        "/root/front/i18n/locales/fr.json"
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      language: "de",
      files: [
        "/root/front/i18n/locales/de.json"
      ]
    },
    {
      code: "es",
      name: "Español",
      language: "es-ES",
      files: [
        "/root/front/i18n/locales/es.json"
      ]
    },
    {
      code: "pt",
      name: "Português",
      language: "pt-PT",
      files: [
        "/root/front/i18n/locales/pt.json"
      ]
    },
    {
      code: "it",
      name: "Italiano",
      language: "it-IT",
      files: [
        "/root/front/i18n/locales/it.json"
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: true,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://staging.groover.co",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: "en-US",
    files: [
      {
        path: "/root/front/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    language: "fr-FR",
    files: [
      {
        path: "/root/front/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    language: "de",
    files: [
      {
        path: "/root/front/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    language: "es-ES",
    files: [
      {
        path: "/root/front/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    name: "Português",
    language: "pt-PT",
    files: [
      {
        path: "/root/front/i18n/locales/pt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    name: "Italiano",
    language: "it-IT",
    files: [
      {
        path: "/root/front/i18n/locales/it.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/